<script>

import AgendamentoHistorico from "@/components/EspacoDoColaborador/PontoExcecao/Historicos/AgendamentoHistorico.vue";
import CompensacoesHistorico from "@/components/EspacoDoColaborador/PontoExcecao/Historicos/CompensacoesHistorico.vue";
import ModalDetalheRegistro from "@/components/EspacoDoColaborador/PontoExcecao/Modais/ModalDetalheRegistro.vue";
import api from "@/services/Api";

const MESES = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

const MESES_POR_PAGINA = 6;

export default {
  components: {CompensacoesHistorico, AgendamentoHistorico, ModalDetalheRegistro},
  data() {
    const hoje = new Date();
    const mesAtual = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
    const proximo = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 1);
    const mesProximo = `${proximo.getFullYear()}-${String(proximo.getMonth() + 1).padStart(2, '0')}`;
    return {
      registros: [],
      compensacoes: [],
      bancoHoras: [],
      tab: 'tab-0',
      compensacoesHistoricoId: null,
      registrosHistoricoId: null,
      selectedHistoricoItem: null,
      tipo: [],
      tiposHorasInfo: [],
      tipoCompensacao: [],
      filtros: {
        de: null,
        ate: null,
        tipo: [],
      },
      rangeMenu: false,
      rangeTemp: [],
      modalDetalhe: false,
      detalheRegistro: {},
      loaderDetalhe: false,
      paginaAtual: 1,
      mesEsquerda: mesAtual,
      mesDireita: mesProximo,
    };
  },

  methods: {
    gotoHistoricoRegistros(id) {
      this.registrosHistoricoId = id;
    },
    gotoHistoricoCompensacoes(id) {
      this.compensacoesHistoricoId = id;
    },
    gotoMain() {
      this.tab = 'tab-0';
      this.registrosHistoricoId = null;
      this.compensacoesHistoricoId = null;
      this.selectedHistoricoItem = null;
    },
    verDetalhe(row) {
      if (row.kind === 'registro') {
        this.abrirDetalheRegistro(row.id);
      } else {
        this.gotoHistoricoCompensacoes(row.id);
      }
    },
    async abrirDetalheRegistro(id) {
      this.detalheRegistro = {};
      this.modalDetalhe = true;
      this.loaderDetalhe = true;
      try {
        const {data} = await api.get(`/ponto-por-excecao/registros-banco-hora/detalhe/${id}`);
        const minutos = this.decorridoParaMinutos(data.decorrido);
        const positivo = this.sinalPorTipo[data.tipo] !== false;
        const totalMinutos = positivo ? minutos : -minutos;
        this.detalheRegistro = {
          ...data,
          totalMinutos: totalMinutos,
          totalLabel: this.minutosParaLabel(totalMinutos, true),
        };
      } catch (e) {
        console.error("Erro ao buscar detalhe do registro:", e);
      } finally {
        this.loaderDetalhe = false;
      }
    },
    limparFiltro() {
      this.filtros = {
        de: null,
        ate: null,
        tipo: [],
      };
      this.rangeTemp = [];
      this.fetchTable();
    },
    /* --- Filtro de intervalo (De/Até) --- */
    addMesAno(anoMes, delta) {
      const [ano, mes] = anoMes.split('-').map(Number);
      const d = new Date(ano, (mes - 1) + delta, 1);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    },
    aplicarRange() {
      const datas = [...this.rangeTemp].filter(Boolean).sort();
      this.filtros.de = datas[0] || null;
      this.filtros.ate = datas[1] || datas[0] || null;
      this.rangeMenu = false;
      this.fetchTable();
    },
    limparRange() {
      this.rangeTemp = [];
      this.filtros.de = null;
      this.filtros.ate = null;
      this.fetchTable();
    },
    /* --- Conversões / formatação --- */
    decorridoParaMinutos(valor) {
      if (valor === null || valor === undefined) return 0;
      if (typeof valor === 'number') return valor;
      const partes = String(valor).split(':');
      const horas = parseInt(partes[0], 10) || 0;
      const minutos = parseInt(partes[1], 10) || 0;
      return (horas * 60) + minutos;
    },
    minutosParaLabel(minutos, comSinal = false) {
      const abs = Math.abs(minutos);
      const horas = Math.floor(abs / 60);
      const min = abs % 60;
      const texto = `${horas}h ${String(min).padStart(2, '0')}m`;
      if (!comSinal || minutos === 0) return texto;
      return `${minutos > 0 ? '+ ' : '- '}${texto}`;
    },
    formatarData(valor) {
      if (!valor) return '-';
      return new Date(valor).toLocaleDateString('pt-BR', {timeZone: 'UTC'});
    },
    dataPorExtenso(valor) {
      if (!valor) return '';
      return new Date(valor).toLocaleDateString('pt-BR', {dateStyle: 'long', timeZone: 'UTC'});
    },
    formatarHora(valor) {
      if (!valor) return '-';
      return String(valor).slice(0, 5);
    },
    /* --- Histórico agrupado por mês --- */
    totalDoGrupoMinutos(items) {
      return items.reduce((acc, item) => acc + item.totalMinutos, 0);
    },
    /* Fecha todos os grupos (meses) da tabela de histórico */
    fecharGruposHistorico() {
      const tabela = this.$refs.historicoTable;
      if (!tabela) return;
      const hoje = new Date();
      const mesAtual = `${MESES[hoje.getMonth()]}/${hoje.getFullYear()}`;
      const grupos = new Set(this.historicoPaginado.map(item => item.mesAno));
      // Abre apenas o mês atual (se houver registros nele); os demais ficam fechados.
      grupos.forEach(grupo => this.$set(tabela.openCache, grupo, grupo === mesAtual));
    },

    fetchTable: async function () {
      try {
        const registrosParams = {};
        if (this.filtros.de) registrosParams.dataInicio = this.filtros.de;
        if (this.filtros.ate) registrosParams.dataFim = this.filtros.ate;

        const [registros, compensacoes, bancoHoras] = await Promise.all([
          api.get("/ponto-por-excecao/registros-banco-hora", {params: registrosParams}),
          api.get("/ponto-por-excecao/compensacao-banco-hora?status=1"),
          api.get("/ponto-por-excecao/saldo-banco-hora")
        ]);

        this.registros = registros.data || [];
        this.compensacoes = compensacoes.data || [];
        this.bancoHoras = bancoHoras.data || {};
      } catch (e) {
        console.error("Erro ao buscar banco de horas:", e);
      }
    },

    fetchFilters: async function () {
      try {
        const [tiposHoras, tiposCompensacao] = await Promise.all([
          api.get("/ponto-por-excecao/tipos-horas/"),
          api.get("/ponto-por-excecao/tipos-compensacao/"),
        ]);
        this.tiposHorasInfo = tiposHoras.data || [];
        this.tipo = this.tiposHorasInfo.map(r => r.ds_tipo_hora);
        this.tipoCompensacao = tiposCompensacao.data.map(item => item.tipo);
      } catch (e) {
        console.error("Erro ao buscar solicitações:", e);
      }
    },
  },

  props: {
    activeTab: String,
  },

  computed: {
    /* Mapa tipo de hora -> se é positiva (extraordinária) ou negativa (ausência) */
    sinalPorTipo() {
      const mapa = {};
      this.tiposHorasInfo.forEach(t => {
        mapa[t.ds_tipo_hora] = t.isHoraPositiva !== false;
      });
      return mapa;
    },
    /* Há algum filtro (intervalo ou tipo) aplicado? */
    filtroAtivo() {
      const {de, ate, tipo} = this.filtros;
      return !!(de || ate || (tipo && tipo.length));
    },
    /* Soma de horas extraordinárias e compensações conforme o filtro aplicado */
    resumoBanco() {
      let extra = 0;
      let comp = 0;
      this.historicoFiltrado.forEach(item => {
        if (item.totalMinutos >= 0) extra += item.totalMinutos;
        else comp += -item.totalMinutos;
      });
      return {extra, comp, saldo: extra - comp};
    },
    /* Saldo exibido no card: usa o filtro quando ativo, senão o saldo real do backend */
    saldoMinutosExibido() {
      if (this.filtroAtivo) return this.resumoBanco.saldo;
      return this.bancoHoras && this.bancoHoras.saldoMinutos != null
          ? this.bancoHoras.saldoMinutos : 0;
    },
    saldoEmHoras() {
      return this.minutosParaLabel(this.saldoMinutosExibido, true);
    },
    saldoZero() {
      return this.saldoMinutosExibido === 0;
    },
    saldoBoolean() {
      return this.saldoMinutosExibido > 0;
    },
    /* Rótulo de status do saldo (badge) */
    saldoStatus() {
      if (this.saldoZero) return 'Sem saldo';
      return this.saldoBoolean ? 'Saldo Positivo' : 'Saldo Negativo';
    },
    saldoClasse() {
      if (this.saldoZero) return 'neutro';
      return this.saldoBoolean ? 'positivo' : 'negativo';
    },
    deLabel() {
      return this.filtros.de ? this.formatarData(this.filtros.de) : '';
    },
    ateLabel() {
      return this.filtros.ate ? this.formatarData(this.filtros.ate) : '';
    },
    atualizadoEm() {
      const data = this.bancoHoras && this.bancoHoras.dataAtualizacao
          ? this.bancoHoras.dataAtualizacao
          : new Date();
      return new Date(data).toLocaleDateString('pt-BR', {timeZone: 'UTC'});
    },
    /* Detalhamento: extraordinárias x compensação (reflete o filtro aplicado) */
    detalhamento() {
      const extraMin = this.resumoBanco.extra;
      const compMin = this.resumoBanco.comp;
      const base = Math.max(extraMin, compMin, 1);
      return {
        extraLabel: this.minutosParaLabel(extraMin, true),
        compLabel: this.minutosParaLabel(-compMin, true),
        extraPct: Math.round((extraMin / base) * 100),
        compPct: Math.round((compMin / base) * 100),
      };
    },
    /* Une registros (extraordinárias) e compensações em uma única linha do tempo */
    historicoCombinado() {
      const linhas = [];

      this.registros.forEach(r => {
        const minutos = this.decorridoParaMinutos(r.decorrido);
        // O sinal depende do tipo de hora (isHoraPositiva): ausências são negativas
        const positivo = this.sinalPorTipo[r.tipo] !== false;
        const totalMinutos = positivo ? minutos : -minutos;
        linhas.push({
          kind: 'registro',
          id: r.id,
          dataObj: new Date(r.dataEvento),
          dataISO: String(r.dataEvento).slice(0, 10),
          dataFmt: this.formatarData(r.dataEvento),
          tipo: r.tipo || 'Hora Extraordinária',
          inicio: this.formatarHora(r.horaInicio),
          fim: this.formatarHora(r.horaFim),
          totalMinutos: totalMinutos,
          totalLabel: this.minutosParaLabel(totalMinutos, true),
        });
      });

      this.compensacoes.forEach(c => {
        const minutos = this.decorridoParaMinutos(
            c.minutosSolicitados !== undefined ? c.minutosSolicitados : c.decorrido);
        const dataRef = c.dataEvento || c.dataSolicitacao;
        linhas.push({
          kind: 'compensacao',
          id: c.id,
          dataObj: new Date(dataRef),
          dataISO: String(dataRef).slice(0, 10),
          dataFmt: this.formatarData(dataRef),
          tipo: c.tipo || 'Hora Compensada',
          inicio: this.formatarHora(c.horaInicio || c.hrInicioCompensada),
          fim: this.formatarHora(c.horaFim || c.hrFimCompensada),
          totalMinutos: -minutos,
          totalLabel: this.minutosParaLabel(-minutos, true),
        });
      });

      return linhas.sort((a, b) => b.dataObj - a.dataObj);
    },
    /* Aplica filtros (De/Até/Tipo) e adiciona a chave de agrupamento por mês */
    historicoFiltrado() {
      const {de, ate, tipo} = this.filtros;
      return this.historicoCombinado
          .filter(item => {
            if (de && item.dataISO < de) return false;
            if (ate && item.dataISO > ate) return false;
            if (tipo && tipo.length > 0 && !tipo.includes(item.tipo)) return false;
            return true;
          })
          .map(item => ({
            ...item,
            mesAno: `${MESES[item.dataObj.getUTCMonth()]}/${item.dataObj.getUTCFullYear()}`,
          }));
    },
    /* Meses (grupos) do mais recente ao mais antigo */
    mesesOrdenados() {
      const vistos = [];
      this.historicoFiltrado.forEach(item => {
        if (!vistos.includes(item.mesAno)) vistos.push(item.mesAno);
      });
      return vistos;
    },
    /* Total de páginas (6 meses por página) */
    totalPaginas() {
      return Math.max(1, Math.ceil(this.mesesOrdenados.length / MESES_POR_PAGINA));
    },
    /* Meses exibidos na página atual */
    mesesPaginaAtual() {
      const inicio = (this.paginaAtual - 1) * MESES_POR_PAGINA;
      return this.mesesOrdenados.slice(inicio, inicio + MESES_POR_PAGINA);
    },
    /* Lançamentos apenas dos meses da página atual */
    historicoPaginado() {
      const meses = this.mesesPaginaAtual;
      return this.historicoFiltrado.filter(item => meses.includes(item.mesAno));
    },
    cabecalhoHistorico() {
      return [
        {text: 'Data', value: 'dataFmt', sortable: false, width: '140px'},
        {text: 'Tipo', value: 'tipo', sortable: false, width: '220px'},
        {text: 'Início', value: 'inicio', sortable: false, width: '110px'},
        {text: 'Fim', value: 'fim', sortable: false, width: '110px'},
        {text: 'Total de Horas', value: 'totalLabel', sortable: false, width: '160px'},
        {text: 'Ação', value: 'acao', sortable: false, align: 'center', width: '110px'},
      ];
    },
  },

  watch: {
    activeTab(newTab) {
      if (newTab === 'tab-0') {
        this.fetchTable();
      }
    },
    /* Ao mudar o filtro, volta para a primeira página */
    historicoFiltrado() {
      this.paginaAtual = 1;
    },
    /* Mantém todos os grupos (meses) fechados por padrão em cada página */
    historicoPaginado() {
      this.fecharGruposHistorico();
      this.$nextTick(this.fecharGruposHistorico);
    },
    /* Mantém os dois calendários sempre em meses consecutivos */
    mesEsquerda(val) {
      const prox = this.addMesAno(val, 1);
      if (this.mesDireita !== prox) this.mesDireita = prox;
    },
    mesDireita(val) {
      const ant = this.addMesAno(val, -1);
      if (this.mesEsquerda !== ant) this.mesEsquerda = ant;
    },
    /* Ao abrir, sincroniza a seleção temporária e o mês exibido */
    rangeMenu(aberto) {
      if (aberto) {
        this.rangeTemp = [this.filtros.de, this.filtros.ate].filter(Boolean);
        if (this.filtros.de) {
          this.mesEsquerda = String(this.filtros.de).slice(0, 7);
        }
      }
    },
    registrosHistoricoId: async function (newId) {
      if (newId) {
        try {
          const response = await api.get("/ponto-por-excecao/historico-agendamento/" + newId);

          this.selectedHistoricoItem = response.data

          this.tab = 'tab-2';
        } catch (e) {
          console.error("Erro ao buscar histórico de agendamento:", e);
        }
      }
    },
    compensacoesHistoricoId: async function (newId) {
      if (newId) {
        try {
          const responseHistorico = await api.get("/ponto-por-excecao/historico-compensacao/" + newId);
          const responseDetalhes = await api.get("/ponto-por-excecao/historico-compensacao/criacao-detalhes/" + newId);

          this.selectedHistoricoItem = {
            historico: responseHistorico.data,
            detalhes: responseDetalhes.data

          }

          this.tab = 'tab-1';
        } catch (e) {
          console.error("Erro ao buscar histórico de compensação:", e);
        }
      }
    },
  },

  mounted: async function () {
    await this.fetchTable()
    await this.fetchFilters()
  },
}
</script>

<template>
  <div>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-0">
        <!-- Cabeçalho -->
        <div class="inicio-titulo bh-cabecalho">
          <v-img
              class="icone-titulo"
              :src="require('@/assets/images/icone/espaco-colaborador/icone_banco_horas.svg')"
          ></v-img>
          <h1 class="bh-titulo">Banco de Horas</h1>
        </div>

        <!-- Saldo + Detalhamento -->
        <v-row class="bh-cards" no-gutters>
          <v-col cols="12" md="5" class="pr-md-3 pb-4 pb-md-0">
            <div class="bh-card-saldo" :class="`saldo-${saldoClasse}`">
              <span class="bh-saldo-rotulo">Banco de Horas</span>
              <span class="bh-saldo-valor" :class="`texto-${saldoClasse}`">{{ saldoEmHoras }}</span>
              <span class="bh-saldo-badge" :class="`badge-${saldoClasse}`">
                <v-icon x-small class="mr-1" :class="`texto-${saldoClasse}`">fas fa-circle</v-icon>
                {{ saldoStatus }}
              </span>
              <span class="bh-saldo-atualizado">
                <template v-if="filtros.de || filtros.ate">
                  Exibindo o período de
                  <span class="bh-saldo-data">{{ deLabel || ateLabel }}</span> a
                  <span class="bh-saldo-data">{{ ateLabel || deLabel }}</span>
                </template>
                <template v-else>
                  Atualizado em <span class="bh-saldo-data bh-saldo-data--atualizado">{{ atualizadoEm }}</span>
                </template>
              </span>
            </div>
          </v-col>

          <v-col cols="12" md="7" class="pl-md-3">
            <div class="bh-card-detalhamento">
              <span class="bh-detalhe-titulo">Detalhamento</span>

              <div class="bh-detalhe-item">
                <div class="bh-detalhe-linha">
                  <span class="bh-detalhe-rotulo">Horas Extraordinárias</span>
                  <span class="texto-positivo">{{ detalhamento.extraLabel }}</span>
                </div>
                <div class="bh-barra">
                  <div class="bh-barra-preenchida barra-positivo"
                       :style="{ width: detalhamento.extraPct + '%' }"></div>
                </div>
              </div>

              <div class="bh-detalhe-item">
                <div class="bh-detalhe-linha">
                  <span class="bh-detalhe-rotulo">Compensação</span>
                  <span class="texto-negativo">{{ detalhamento.compLabel }}</span>
                </div>
                <div class="bh-barra">
                  <div class="bh-barra-preenchida barra-negativo"
                       :style="{ width: detalhamento.compPct + '%' }"></div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Histórico -->
        <h2 class="titulo-avaliacao titulo-secao bh-titulo-historico pt-8">
          Histórico
          <span>Veja os detalhes do seu banco de horas</span>
        </h2>

        <!-- Filtros -->
        <v-row class="py-4" align="center">
          <v-col cols="12" md="6">
            <v-menu
                v-model="rangeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="input-field bh-range-field" v-on="on" v-bind="attrs">
                  <div class="bh-range-lado">
                    <span class="input-field-text bh-range-label">De</span>
                    <span class="bh-range-valor">{{ deLabel }}</span>
                  </div>
                  <div class="bh-range-divisor"></div>
                  <div class="bh-range-lado">
                    <span class="input-field-text bh-range-label">Até</span>
                    <span class="bh-range-valor">{{ ateLabel }}</span>
                  </div>
                  <v-icon class="input-field-text bh-range-icone">fas fa-calendar-days</v-icon>
                </div>
              </template>

              <v-card class="bh-range-card">
                <div class="bh-range-pickers">
                  <v-date-picker
                      v-model="rangeTemp"
                      :picker-date.sync="mesEsquerda"
                      range
                      no-title
                      locale="pt-br"
                      color="#278b97"
                      class="bh-range-picker"
                  ></v-date-picker>
                  <v-date-picker
                      v-model="rangeTemp"
                      :picker-date.sync="mesDireita"
                      range
                      no-title
                      locale="pt-br"
                      color="#278b97"
                      class="bh-range-picker"
                  ></v-date-picker>
                </div>
                <div class="bh-range-acoes">
                  <v-btn text color="#278b97" class="text-none" @click="limparRange">Limpar</v-btn>
                  <v-btn depressed color="#278b97" class="white--text text-none" @click="aplicarRange">Aplicar</v-btn>
                </div>
              </v-card>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
                class="input-field bh-tipo"
                clearable
                outlined
                dense
                hide-details="auto"
                height="40px"
                v-model="filtros.tipo"
                :items="tipo"
                multiple
                :menu-props="{ offsetY: true, maxHeight: 320 }"
            >
              <template slot="label">
                <span class="input-field-text">Tipo:</span>
              </template>
              <template v-slot:selection="{ index }">
                <span v-if="index === 0" class="bh-tipo-selecao">
                  {{ filtros.tipo.length === 1 ? filtros.tipo[0] : filtros.tipo.length + ' selecionados' }}
                </span>
              </template>
              <template v-slot:append>
                <v-icon class="input-field-text">fas fa-chevron-down</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-btn @click="limparFiltro()" class="botao-limpar">Limpar Busca</v-btn>
          </v-col>
        </v-row>

        <!-- Tabela agrupada por mês -->
        <v-data-table
            ref="historicoTable"
            class="bh-tabela"
            :headers="cabecalhoHistorico"
            :items="historicoPaginado"
            group-by="mesAno"
            :items-per-page="-1"
            :mobile-breakpoint="0"
            hide-default-footer
            no-data-text="Não há lançamentos no seu banco de horas"
        >
          <template v-slot:group.header="{ group, items, isOpen, toggle }">
            <td class="bh-grupo bh-grupo-mes" @click="toggle">{{ group }}</td>
            <td class="bh-grupo">{{ items.length }} {{ items.length === 1 ? 'lançamento' : 'lançamentos' }}</td>
            <td class="bh-grupo">-</td>
            <td class="bh-grupo">-</td>
            <td class="bh-grupo">
              <span :class="totalDoGrupoMinutos(items) >= 0 ? 'texto-positivo' : 'texto-negativo'">
                {{ minutosParaLabel(totalDoGrupoMinutos(items), true) }}
              </span>
            </td>
            <td class="bh-grupo text-center">
              <v-icon @click="toggle">
                {{ isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
              </v-icon>
            </td>
          </template>

          <template v-slot:item.totalLabel="{ item }">
            <span :class="item.totalMinutos >= 0 ? 'texto-positivo' : 'texto-negativo'">
              {{ item.totalLabel }}
            </span>
          </template>

          <template v-slot:item.acao="{ item }">
            <div class="acoes-tabela">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      icon
                      class="btn-acao-tabela"
                      :aria-label="`Ver detalhes do lançamento de ${dataPorExtenso(item.dataISO)}, ${item.tipo}`"
                      v-on="on"
                      @click="verDetalhe(item)"
                  >
                    <v-icon class="icone-acao">fa-solid fa-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalhes do lançamento</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>

        <v-pagination
            v-if="totalPaginas > 1"
            v-model="paginaAtual"
            :length="totalPaginas"
            :total-visible="7"
            color="#008693"
            class="bh-paginacao mt-6"
        />
      </v-tab-item>

      <v-tab-item value="tab-1">
        <CompensacoesHistorico v-if="selectedHistoricoItem" :item="selectedHistoricoItem"/>
        <v-btn @click="gotoMain" class="botao-limpar mt-4">Voltar</v-btn>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <AgendamentoHistorico v-if="selectedHistoricoItem" :item="selectedHistoricoItem"/>
        <v-btn @click="gotoMain" class="botao-limpar mt-4">Voltar</v-btn>
      </v-tab-item>
    </v-tabs-items>

    <ModalDetalheRegistro
        :show="modalDetalhe"
        :detalhe="detalheRegistro"
        :loader="loaderDetalhe"
        @fecha-modal="modalDetalhe = false"
    />
  </div>
</template>

<style scoped>
/* Cabeçalho */
.bh-cabecalho {
  margin-bottom: 1.5rem;
}

.bh-titulo {
  font: normal normal 800 20px/24px Montserrat;
  text-transform: none;
  color: #278b97;
  margin: 0 !important;
}

/* Cores auxiliares */
.texto-positivo {
  color: #2e9e52;
}

.texto-negativo {
  color: #db1427;
}

.texto-neutro {
  color: #707070;
}

/* Card de saldo */
.bh-cards {
  margin-top: 0.5rem;
}

.bh-card-saldo {
  border: 2px solid;
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  gap: 0.5rem;
}

.bh-card-saldo.saldo-positivo {
  border-color: #2e9e52;
}

.bh-card-saldo.saldo-negativo {
  border-color: #db1427;
}

.bh-card-saldo.saldo-neutro {
  border-color: #b6b0ae;
}

.bh-saldo-rotulo {
  font: normal normal 700 14px/17px Montserrat;
  color: #707070;
}

.bh-saldo-valor {
  font: normal normal 900 35px/42px Montserrat;
}

.bh-saldo-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 10px;
  font: normal normal 700 13px/16px Montserrat;
}

.bh-saldo-badge.badge-positivo {
  background-color: rgba(46, 158, 82, 0.13);
  color: #2e9e52;
}

.bh-saldo-badge.badge-negativo {
  background-color: rgba(219, 20, 39, 0.13);
  color: #db1427;
}

.bh-saldo-badge.badge-neutro {
  background-color: rgba(112, 112, 112, 0.13);
  color: #707070;
}

.bh-saldo-atualizado {
  font: normal normal 600 12px/15px Montserrat;
  color: #707070;
}

.bh-saldo-data {
  font-weight: 800;
  color: #3d3d3d;
}

.bh-saldo-data--atualizado {
  font-weight: 600;
}

/* Card de detalhamento */
.bh-card-detalhamento {
  border: 1px solid #7db9c1;
  border-radius: 10px;
  padding: 1rem 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bh-detalhe-titulo {
  font: normal normal 700 14px/17px Montserrat;
  color: #3d3d3d;
}

.bh-detalhe-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.bh-detalhe-linha {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font: normal normal 700 14px/17px Montserrat;
}

.bh-detalhe-rotulo {
  color: #707070;
}

.bh-barra {
  width: 100%;
  height: 5px;
  border-radius: 8px;
  background-color: #edefee;
  overflow: hidden;
}

.bh-barra-preenchida {
  height: 100%;
  border-radius: 8px;
  transition: width 0.4s ease;
}

.bh-barra-preenchida.barra-positivo {
  background-color: #2e9e52;
}

.bh-barra-preenchida.barra-negativo {
  background-color: #db1427;
}

/* Título do histórico (usa design system titulo-avaliacao) */
.bh-titulo-historico {
  color: #278b97;
  text-transform: none;
}

.bh-titulo-historico span {
  border-left: 2px solid #278b97;
  padding-left: 0.75rem;
  margin-left: 0.75rem;
  font-size: 0.75rem;
  font-weight: 900;
  color: #278b97;
  text-transform: none;
}

/* Campo Tipo: seleção condensada em uma linha */
.bh-tipo >>> .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}

.bh-tipo-selecao {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3d3d3d;
  font-size: 0.875rem;
}

/* Paginação */
.bh-paginacao >>> .v-pagination {
  gap: 8px;
}

.bh-paginacao >>> .v-pagination__item,
.bh-paginacao >>> .v-pagination__navigation {
  box-shadow: none;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  border-radius: 30px !important;
}

.bh-paginacao >>> .v-pagination__item {
  background: #f8f9fa;
  color: #3d3d3d;
}

.bh-paginacao >>> .v-pagination__item--active {
  color: #ffffff;
}

.bh-paginacao >>> .v-pagination__navigation {
  background: #f8f9fa;
}

/* Iguala a altura do botão Limpar Busca à dos filtros (40px) */
.botao-limpar {
  height: 40px !important;
  min-height: 40px !important;
}

/* Campo combinado De | Até */
.bh-range-field {
  display: flex;
  align-items: center;
  background-color: #edefee;
  border-radius: 12px;
  height: 40px;
  padding: 0 1rem;
  cursor: pointer;
}

.bh-range-lado {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
}

.bh-range-label {
  margin: 0 !important;
  font-weight: 600;
}

.bh-range-valor {
  color: #3d3d3d;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bh-range-divisor {
  width: 1px;
  height: 60%;
  background-color: #b6b0ae;
  margin: 0 1rem;
}

.bh-range-icone {
  margin: 0 0 0 0.5rem !important;
}

/* Popup do intervalo */
.bh-range-card {
  padding: 0.75rem;
}

.bh-range-pickers {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.bh-range-picker {
  box-shadow: none !important;
}

/* Esconde as setas internas: navegação só nas bordas externas (como no protótipo) */
.bh-range-pickers .bh-range-picker:first-child >>> .v-date-picker-header > button:last-of-type {
  visibility: hidden;
}

.bh-range-pickers .bh-range-picker:last-child >>> .v-date-picker-header > button:first-of-type {
  visibility: hidden;
}

@media (max-width: 599px) {
  /* Empilhados no mobile: restaura as duas setas em cada calendário */
  .bh-range-pickers .bh-range-picker >>> .v-date-picker-header > button {
    visibility: visible;
  }
}

/* --- Range highlight: bloco sólido (in-range background) --- */
/* Sem espaçamento entre células: o realce vira um bloco contínuo */
.bh-range-pickers >>> .v-date-picker-table table {
  border-collapse: collapse !important;
}

.bh-range-pickers >>> .v-date-picker-table--date td {
  width: auto;
  padding: 0;
}

/* Célula dentro do intervalo: fundo preenche a célula inteira (bloco cheio, sem vãos) */
.bh-range-pickers >>> .v-date-picker-table--date td:has(.v-btn--active) {
  background-color: rgba(37, 139, 151, 0.15);
}

/* Cantos arredondados nas extremidades do bloco */
.bh-range-pickers >>> .v-date-picker-table--date td:has(.v-date-picker--first-in-range) {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.bh-range-pickers >>> .v-date-picker-table--date td:has(.v-date-picker--last-in-range) {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

/* Seleção de um único dia: só o círculo, sem bloco */
.bh-range-pickers >>> .v-date-picker-table--date td:has(.v-date-picker--first-in-range.v-date-picker--last-in-range) {
  background-color: transparent;
  border-radius: 0;
}

/* Remove o overlay de estado do Vuetify (o "círculo cinza" nos dias do intervalo) */
.bh-range-pickers >>> .v-date-picker-table .v-btn--active::before {
  opacity: 0 !important;
}

/* Dias no meio do intervalo: botão transparente, mostra só o número */
.bh-range-pickers >>> .v-date-picker-table .v-btn.v-btn--active:not(.v-date-picker--first-in-range):not(.v-date-picker--last-in-range) {
  background-color: transparent !important;
  color: #3d3d3d !important;
  box-shadow: none !important;
}

.bh-range-pickers >>> .v-date-picker-table .v-btn.v-btn--active:not(.v-date-picker--first-in-range):not(.v-date-picker--last-in-range) .v-btn__content {
  color: #3d3d3d !important;
}

/* Pontas do intervalo: círculo teal preenchido sobre o bloco */
.bh-range-pickers >>> .v-date-picker-table .v-date-picker--first-in-range,
.bh-range-pickers >>> .v-date-picker-table .v-date-picker--last-in-range {
  background-color: #258b97 !important;
  color: #fff !important;
  border-radius: 50% !important;
  box-shadow: none !important;
}

.bh-range-pickers >>> .v-date-picker-table .v-date-picker--first-in-range .v-btn__content,
.bh-range-pickers >>> .v-date-picker-table .v-date-picker--last-in-range .v-btn__content {
  color: #fff !important;
}

.bh-range-acoes {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem 0.25rem;
  border-top: 1px solid #edefee;
}

/* Larguras de coluna estáticas: evita o reflow ao abrir os meses / selecionar tipos longos */
.bh-tabela >>> table {
  table-layout: fixed;
  min-width: 820px;
}

/* No mobile a tabela mantém as colunas e rola na horizontal (sem quebrar o layout) */
.bh-tabela >>> .v-data-table__wrapper {
  overflow-x: auto;
}

/* Tipo pode quebrar em 2 linhas se necessário, sem empurrar as outras colunas */
.bh-tabela >>> table td,
.bh-tabela >>> table th {
  white-space: normal;
  word-break: break-word;
}

/* Linha de agrupamento por mês */
.bh-tabela >>> .v-row-group__header td.bh-grupo {
  background-color: #edefee !important;
  color: #3d3d3d;
  font: normal normal 700 14px/17px Montserrat;
  cursor: pointer;
}

/* Deep (>>>): não exige o atributo de escopo no <td>, garantindo a cor do mês
   em TODOS os grupos — inclusive o primeiro, que vinha herdando a cor global. */
.bh-tabela >>> .v-row-group__header td.bh-grupo-mes {
  font-weight: 800 !important;
  color: #278b97 !important;
}

.bh-tabela >>> .v-row-group__header .v-icon {
  color: #258b97;
  cursor: pointer;
}

/* ---- Ajustes para telas pequenas ---- */
@media (max-width: 600px) {
  .bh-card-detalhamento {
    padding: 1rem 1.25rem;
  }

  .bh-card-saldo {
    padding: 1rem 1.25rem;
  }

  .bh-saldo-valor {
    font-size: 30px;
    line-height: 36px;
  }

  /* Popup do intervalo: calendários empilhados e ocupando a largura disponível */
  .bh-range-card {
    max-width: 92vw;
  }

  .bh-range-pickers {
    justify-content: center;
  }
}
</style>
